export default __webpack_public_path__ + "static/media/paper12.0c1549d8.JPG";